import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxState } from "../..";
import { Subscription, UserSlice } from "./types";

const initialState: UserSlice = {
  access_token: "",
  name: "",
  type: "ADMIN",
  id: "",
  createdAt: new Date()
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoginData: (state, { payload }: PayloadAction<UserSlice>) => {
      return payload;
    },
    setAccessToken: (state, { payload }: PayloadAction<string>) => {
      state.access_token = payload;
    },
    setSubscription: (state, { payload }: PayloadAction<Subscription>) => {
      state.subscription = payload;
      // Só promove a assinatura do próprio usuário a assinatura da clínica quando
      // ela é de fato ativa: um payload vazio (ex.: dentista abrindo a URL de
      // sucesso, ou webhook do Stripe ainda não processado) não pode apagar o
      // clinicSubscription válido e trancar o usuário fora.
      if (payload?.isActive) state.clinicSubscription = payload;
    },
    setOnboardingCompleted: (state) => {
      state.onboardingCompletedAt = new Date().toISOString();
    }
  }
});

export const {
  setAccessToken,
  setLoginData,
  setSubscription,
  setOnboardingCompleted
} = userSlice.actions;

export const selectAccessToken = (state: ReduxState) => state.user.access_token;
export const selectName = (state: ReduxState) => String(state.user.name);
export const selectAvatarUrl = (state: ReduxState) => state.user.avatarUrl;

// O banner de trial aparece quando a clínica não tem assinatura ativa e há um
// fim de trial conhecido. Layout e TrialBanner leem daqui para não divergirem.
export const selectShowTrialBanner = (state: ReduxState) =>
  !state.user.clinicSubscription?.isActive &&
  Boolean(state.user.clinicTrialEndsAt);
